import styled from 'styled-components';

import { inputFocus } from '@xemplo/input-utils';
import { BodyXSmallSemiBold } from '@xemplo/style-constants';
import { XemploInput } from '@xemplo/xemplo-input';

/** This styling simulates the container to be on a focus state */
export const CustomXemploInput = styled(XemploInput)`
  &.open,
  &:focus-within:not(.invalid) {
    ${inputFocus};
    padding: 12px 16px;
    > label {
      ${BodyXSmallSemiBold};
      top: 10px;
    }
  }
`;
